import { ChangeDetectorRef, inject, Injectable, signal } from '@angular/core';
import { Subject } from 'rxjs';

export class Toast {
	classname?: string;
	delay?: number;
	message: string = '';
	title?: string;
	autoclose?: boolean = false;
}

@Injectable({
	providedIn: 'root',
})
export class ToastMessageService {
	public readonly toasts = signal<Toast[]>([]);

	show(toast: Toast) {
		this.toasts.update((toasts) => [...toasts, toast]);
	}
	showSuccess(message: string) {
		const toast: Toast = {
			message: message,
			classname: 'bg-success text-light',
			delay: 3000
		};

		this.toasts.update((toasts) => [...toasts, toast]);
	}

	showError(message: string, delay: number = 0) {
		const toast: Toast = {
			message: message,
			classname: 'bg-danger text-light',
			autoclose: delay > 0,
			title: ' ',
			delay: delay,
		};
		this.toasts.update((toasts) => [...toasts, toast]);
	}

	showWarning(message: string) {
		const toast: Toast = {
			message: message,
			classname: 'bg-warning text-dark',
			delay: 3000
		};
		this.toasts.update((toasts) => [...toasts, toast]);
	}

	remove(toast: Toast) {
		this.toasts.update((toasts) => toasts.filter((t) => t !== toast));
	}

	clear() {
		this.toasts.set([]);
	}
}
